import { streem } from 'streem-sdk-protobuf';
import { createContextFactory } from '@streem/toolbox';
import { useObservable } from '../hooks/rxjs';
export const [RoomSessionProvider, useRoomSession] = createContextFactory('RoomSession');
export const useRoomSessionDetections = () => {
    const roomSession = useRoomSession();
    const [detections] = useObservable(roomSession.detections.getDetections({
        types: [
            streem.api.Detection.Type.DETECTION_TYPE_MODEL,
            streem.api.Detection.Type.DETECTION_TYPE_SERIAL,
        ],
    }));
    return detections || [];
};
export const useStreemshotResponses = () => {
    const roomSession = useRoomSession();
    const [streemshots] = useObservable(roomSession.streemshots.responses);
    return streemshots ?? [];
};
//# sourceMappingURL=room_session.js.map